import {ISO_WEEKDAYS} from '../../constants'

const isoWeekdayToDayId = isoWeekday => ISO_WEEKDAYS[isoWeekday]

export {isoWeekdayToDayId}
